import { render, staticRenderFns } from "./DemandExport.vue?vue&type=template&id=bcd531e8"
import script from "./DemandExport.vue?vue&type=script&lang=js"
export * from "./DemandExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports